import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, InputOnChangeData } from 'semantic-ui-react';
import styles from './SiteSearch.module.scss';

export interface SearchProps {
    onSearch: () => void;
    onChange: (
        event: React.ChangeEvent<HTMLInputElement>,
        data: InputOnChangeData,
    ) => void;
    value: any;
    placeholder?: string;
    className?: string;
}

export const SiteSearch: FunctionComponent<SearchProps> = ({
    onSearch,
    ...props
}) => {
    const { t } = useTranslation();
    
    const onKeyDown = (e: { key: string }) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };

    return (
        <div className={styles.searchWrapper} role="search">
            <div className={styles.searchInputWrapper}>
                <Input
                    {...props}
                    onChange={props.onChange}
                    onKeyDown={onKeyDown}
                    className={styles.searchBar}
                    value={props.value}
                    placeholder={'Search...'}
                    aria-label={t('Search.SearchSite', 'Search site')}
                />
            </div>
            <button
                type="button"
                className={styles.searchIconWrapper}
                onClick={() => {
                    onSearch();
                }}
                aria-label={t('Search.SubmitSearch', 'Submit search')}
            >
                <span className={styles.searchIcon}>
                    <i className="far fa-search" aria-hidden="true"></i>
                </span>
            </button>
        </div>
    );
};

SiteSearch.defaultProps = {
    placeholder: 'Search',
};
